module.exports = __webpack_public_path__ + "img/online.83a93be4.png";